<template>
  <AdminLayout>
      <h2>PRODUCT</h2><br>
      <div class="box-default" style="margin-bottom: 20px">
          <button @click="closeEdit" v-if="isEdit" class="btn-default" style="margin-bottom: 20px">Close</button>
          <h3 style="display:inline-block;margin-left: 15px;" v-if="isEdit">{{data.title}}</h3>

          <form @submit.prevent="formData(selectedKey)">
            <div class="form-group" v-if="!isEdit">
                <input type="text" class="form-control" placeholder="Title" v-model="data.title" required>
            </div>
            <div class="form-group">
                <label for="">Image Thumbnail : </label>
                <input type="file" id="imageThumbnail">
            </div>
            <div class="form-group">
                <label for="">Image Detail : </label>
                <input type="file" id="imageDetail">
            </div>
            <div class="form-group">
                <input type="number" class="form-control" placeholder="Price" v-model="data.price" required>
            </div>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Url Product" v-model="data.urlProduct" required>
            </div>
            <div class="form-group">
                <label style="margin-bottom: 8px;display:block">Description:</label>
                <wysiwyg v-model="data.description" required/>
            </div>
            <div class="form-group">
                <select name="" id="" style="width: 100%; padding: 10px;" v-model="data.category" required multiple>
                    <option value="Graphic Design">Graphic Design</option>
                    <option value="UI / UX">UI / UX</option>
                    <option value="Web Template">Web Template</option>
                    <option value="Code / Library">Code / Library</option>
                </select>
            </div>
            <div class="form-group">
                <select name="" id="" style="width: 100%; padding: 10px;" v-model="data.license" required>
                    <option value="Free Personal Use">Free Personal Use</option>
                    <option value="Free Commercial Use">Free Commercial Use</option>
                </select>
            </div>
            <!-- <div class="form-group">
                <input type="text" class="form-control" placeholder="Collaboration" v-model="data.collaboration" required>
            </div> -->

            <button type="submit" class="btn-default">{{isEdit ? 'Submit Updated Data ' : 'Submit'}}</button>
          </form>
      </div>

      <table style="width: 100%">
          <thead>
              <th>Title</th>
              <th>Category</th>
              <th>Thumbnail</th>
              <th>Action</th>
          </thead>
          <tbody>
              <tr v-for="item in listPortfolios" :key="item.key">
                  <td class="text-center">{{item.title}}</td>
                  <td class="text-center">
                    <span v-for="category in item.category" :key="category">{{category}}</span>
                  </td>
                  <td class="text-center"><img style="height: 100px;" v-lazy="item.imageThumbnail" alt=""></td>
                  <td class="text-center">
                      <button @click="showEdit(item)" class="btn-default" style="margin-right: 5px;">Edit</button>
                      <button @click="deleteItem(item.key)" class="btn-default">Delete</button>
                  </td>
              </tr>
          </tbody>
      </table>
  </AdminLayout>
</template>

<style lang="scss">
    @import "~vue-wysiwyg/dist/vueWysiwyg.css";
    .box-default{
        width: 100%;
        padding: 30px;
        background-color: #f2f2f2;
        border: 0.6px solid #ddd;
    }
    .form-control{
        background-color: #f2f2f2;
    }
</style>

<script>
import Vue from 'vue'
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {})

import firebase from 'firebase/app'

import AdminLayout from '@/components/AdminLayout'
export default {
    data(){
        return{
            isEdit: false,
            selectedKey: null,
            listPortfolios: [],
            data: {
                title: '',
                description: '',
                urlProduct: '',
                price: '',
                license: 'Free Personal Use',
                category: 'Graphic Design',
                // collaboration: '',
                lastUpdated: new Date()
            }
        }
    },
    computed:{
        slug(){
            let slug = "";
            const titleLower = this.data.title.toLowerCase();
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            slug = slug.replace(/đ/gi, 'd');
            slug = slug.replace(/\s*$/g, '');
            slug = slug.replace(/\s+/g, '-');
            return slug;
        }
    },
    methods:{
        clearObj(){
            this.data =  {
                title: '',
                description: '',
                category: 'Graphic Design',
                collaboration: '',
                lastUpdated: new Date()
            }

            document.getElementById("imageThumbnail").value = "";
            document.getElementById("imageDetail").value = "";
        },
        listData(){
            const self = this
            firebase.firestore()
                .collection('products')
                .orderBy('lastUpdated', 'desc')
                .onSnapshot(querySnapshoot => {
                    self.listPortfolios = querySnapshoot.docs.map(doc =>{
                        return({
                            key: doc.id,
                          ...doc.data()
                        })
                })
            })
        },
        uploadImage(key, imageThumbnail, imageDetail){
            if(imageThumbnail){
                firebase.storage().ref('product-image/' + new Date() + key + 'thumb').put(imageThumbnail)
                .then(params => params.ref.getDownloadURL())
                .then((url) => {
                    // UPDATE IMAGE URL IN DATABASE
                    firebase.firestore().collection('products').doc(key).update({
                        imageThumbnail: url
                    })
                })
            }
            if(imageDetail){
                firebase.storage().ref('product-image/' + new Date() + key + 'detail').put(imageDetail)
                .then(params => params.ref.getDownloadURL())
                .then((url) => {
                    // UPDATE IMAGE URL IN DATABASE
                    firebase.firestore().collection('products').doc(key).update({
                        imageDetail: url
                    })
                })
            }
        },
        formData(key){
            const imageThumbnail = document.querySelector('#imageThumbnail').files[0]
            const imageDetail = document.querySelector('#imageDetail').files[0]

            // STORE DATA
            if(!this.isEdit){
                firebase.firestore().collection('products').doc(this.slug).set(this.data)
                .then((data) => {
                    const key = this.slug
                    this.uploadImage(key, imageThumbnail, imageDetail)
                }).then(() =>{
                    alert('success')
                    this.clearObj()
                    this.listData()
                }).catch(err => {
                    alert(err)
                })
            }else{
                firebase.firestore().collection('products').doc(this.selectedKey).update(this.data)
                .then((data) => {
                    const key = this.slug
                    this.uploadImage(key, imageThumbnail, imageDetail)
                }).then(() =>{
                    alert('success')
                    this.listData()
                }).catch(err => {
                    alert(err)
                })
            }
        },
        closeEdit(){
            this.isEdit = false
            this.clearObj()
        },
        showEdit(item){
            document.documentElement.scrollTop = 0;
            this.isEdit = true
            this.selectedKey = item.key
            this.data.title = item.title
            this.data.category = item.category
            this.data.description = item.description
            this.data.license = item.license
            this.data.price = item.price
            this.data.urlProduct = item.urlProduct
        },
        deleteItem(key){
            const self = this
            if(confirm('are you sure to delete this item ?')){
                firebase.firestore().collection('products').doc(key)
                .delete().then(()=>{
                    alert('success delete!')
                    self.listData()
                }).catch(err => {
                    alert(err)
                })
            }
        }
    },
    components: {
        AdminLayout
    },
    mounted(){
        this.listData()
    }
}
</script>

<style>

</style>